import { render, staticRenderFns } from "./ShippingBoxes.vue?vue&type=template&id=f27a4c58&"
import script from "./ShippingBoxes.vue?vue&type=script&lang=js&"
export * from "./ShippingBoxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports